import Text from 'components/Text/Text';
import React from 'react';
import { ISubCategoriesForIItemCategory } from 'types';
import style from './SubcategoriesScrollView.module.scss';

interface IDishesScrollView {
	data: ISubCategoriesForIItemCategory[];
}

const SubcategoriesScrollView: React.FC<IDishesScrollView> = ({ data }) => {
	return (
		<div className={style.container} data-test="SubcategoriesScrollView">
			{data.length
				? data.map((el) => (
						<div key={el.id} className={style.item}>
							<div className={style.dot} />
							<Text translationKey={el.subCategoryName} withTooltip={true} />
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default SubcategoriesScrollView;
